module.exports = __webpack_public_path__ + "img/mc-donald-thumbnail.e149e1a4.jpg";